import React, {useState, useEffect} from 'react';
import {useRouter} from 'next/router';
import classNames from 'classnames';

import MobileFilter from './MobileFilter';

function UpBlock(props) {
	const {styles, pageUrl} = props;
	return (
		<>
			<div className='row'>
				<div className={classNames('col-md-12', styles.deskUpBlock)}>
					<SortBy styles={styles} filters={props.filters} pageUrl={pageUrl} />
				</div>
			</div>
			<MobileFilter
				{...props}
				url={pageUrl}
				filters={props.filters}
				styles={styles}
			/>
		</>
	);
}

const wrapperRef = React.createRef();

const sortItems = {
	1: 'Newest First',
	2: 'Price low to high',
	3: 'Price high to low',
	4: 'Alphabetical A-Z',
	5: 'Alphabetical Z-A',
};

function SortBy(props) {
	const router = useRouter();
	const [show, setShow] = useState(false);
	const {styles, filters} = props;

	useEffect(() => {
		const outSideModalClickEvent = event => {
			if (wrapperRef && !wrapperRef.current?.contains(event.target)) {
				setShow(false);
				//removeListener();
			}
		};
		const removeListener = () => {
			document.removeEventListener('mousedown', outSideModalClickEvent);
		};
		document.addEventListener('mousedown', outSideModalClickEvent);

		return () => removeListener;
	}, []);

	const sortby = sort => {
		const query = {...props.filters, sortBy: sort};
		if (filters.sortBy && sort === filters.sortBy) return;
		if (sort === 1) delete query.sortBy;
		delete query.page;
		router.push({pathname: props.pageUrl, query});
		setShow(false);
	};
	return (
		<div
			className={`${styles.upBlock} d-md-flex justify-content-end align-items-center`}
		>
			<div
				ref={wrapperRef}
				className={`${styles.sortBtnGroup} btn-group ${show ? 'show' : ''}`}
			>
				<button
					className={`${styles.btn}  dropdown-toggle`}
					name='recordinput'
					data-toggle='dropdown'
					onClick={() => setShow(!show)}
				>
					{filters.sortBy && filters.sortBy !== 1
						? sortItems[filters.sortBy]
						: 'Sort By'}
				</button>
				<ul
					className={`dropdown-menu ${styles.sortDropdown} ${
						show ? 'show' : ''
					}`}
					aria-labelledby='dropdownMenuButton1'
				>
					{Object.keys(sortItems).map(k => (
						<li key={k}>
							<span onClick={() => sortby(k)}>{sortItems[k]}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}

export default UpBlock;
